import React from "react";
import { useLang } from "../context/LanguageContext";
import PageHero from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import SectionHead from "../components/SectionHead";
import ClientMarquee from "../components/ClientMarquee";

export default function Partners() {
  const { t } = useLang();
  const p = t.partnersSection;

  return (
    <div>
      <PageHero tag={p.tag} title={p.title} desc={p.desc} />
      <section className="py-14 rq-light">
        <div className="rq-container grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {p.list.map((c, i) => (
            <Reveal key={i} delay={(i % 3) * 100}>
              <div className="rq-card p-7 h-full" data-testid={`partner-card-${i}`}>
                <div className="h-14 flex items-center">
                  <img src={c.logo} alt={c.name} loading="lazy" className="max-h-12 max-w-[170px] object-contain" />
                </div>
                <h3 className="font-display mt-5 text-lg font-semibold text-white">{c.name}</h3>
                <p className="mt-3 text-sm leading-relaxed text-[color:var(--rq-muted)]">{c.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="py-16">
        <div className="rq-container">
          <SectionHead tag={t.customersSection.tag} title={t.customersSection.title} desc={t.customersSection.desc} />
          <div className="mt-12 space-y-4">
            <ClientMarquee items={t.customers.slice(0, 8)} />
            <ClientMarquee items={t.customers.slice(8)} reverse />
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="rq-container">
          <div className="rq-card p-10 md:p-14 text-center">
            <span className="rq-tag justify-center">{t.certified.tag}</span>
            <h2 className="font-display mt-4 text-3xl md:text-4xl font-bold text-white">{t.certified.title}</h2>
            <p className="mt-5 max-w-3xl mx-auto text-[color:var(--rq-muted)] leading-relaxed">{t.certified.desc}</p>
          </div>
        </div>
      </section>
    </div>
  );
}
